import React from "react";
import I from "./Icon";
const ConfirmDlg = ({ title, msg, onOk, onCancel, danger = true }) => (
  <div className="mov" onClick={onCancel}>
    <div className="mdl mdl-sm" onClick={e => e.stopPropagation()}>
      <div className="confirm-body">
        <div className="confirm-ic" style={{ background: danger ? "#FEF2F2" : "#EFF6FF" }}>
          <I n={danger ? "trash" : "info"} s={26} c={danger ? "#EF4444" : "#2563EB"} />
        </div>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 13, color: "var(--t2)", lineHeight: 1.6 }}>{msg}</div>
      </div>
      <div className="mfoot">
        <button className="btn bg_" onClick={onCancel}>Cancel</button>
        <button className={`btn ${danger ? "bdn" : "bp"}`} onClick={onOk}>{danger ? "Yes, Delete" : "Confirm"}</button>
      </div>
    </div>
  </div>
);

export default ConfirmDlg;
